module.exports = __webpack_public_path__ + "static/black-alsatian-web-design-514de3dbd0b6f26cb58c779712c1fe01.svg";